import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import { CheckRounded, CloseRounded } from '@mui/icons-material';
import { NEW_AUDIO_STATUS } from '@src/constants/voiceCloning';
import { StyledCheckAudioQuality } from './index.style';
import { qualities } from '../data/qualities';

const CheckAudioQuality = ({ qualityStates, conditionShowNote, audio }) => {
  const { t } = useTranslation();

  const isSuccessQuality = Object.values(qualityStates).every((state) => state);
  const conditionShowQuality =
    audio?.status === NEW_AUDIO_STATUS.PASSED ||
    audio?.status === NEW_AUDIO_STATUS.GOOD ||
    (audio?.status === NEW_AUDIO_STATUS.PENDING &&
      (!audio?.note || (!isSuccessQuality && audio?.note)));

  const SuccessQuality = () => (
    <Box className="success">
      <Box className="success-title">
        <CheckRounded className="success-title-icon" />
        <Typography>{t('audioQualityPassed')}</Typography>
      </Box>
      <Typography className="success-check">
        {t('pleaseCheckAudioAgain')}
      </Typography>
    </Box>
  );

  const ErrorQuality = () => (
    <Box className="error">
      <Box className="box-title">
        <Typography className="evaluate-text">{t('evaluate')}</Typography>
      </Box>
      <Box className="box-quality">
        {qualities.map((item, index) => (
          <Box
            key={item.id}
            className={`box-quality-item ${
              index === qualities.length - 1 ? 'last-item' : ''
            }`}
          >
            {qualityStates[item.id] ? (
              <CheckRounded className="check-icon" />
            ) : (
              <CloseRounded className="close-icon" />
            )}
            <Typography className="quality-text" key={item.id}>
              {t(item.text)}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );

  return (
    <StyledCheckAudioQuality>
      {conditionShowNote && isSuccessQuality && <SuccessQuality />}
      {conditionShowQuality && <ErrorQuality />}
    </StyledCheckAudioQuality>
  );
};

export default CheckAudioQuality;
